package com.stiv_apps.facecutweb.section

import androidx.compose.runtime.Composable
import com.stiv_apps.facecutweb.components.Header
import com.stiv_apps.facecutweb.style.StoreImageStyle
import com.stiv_apps.facecutweb.style.TextSelectionStyle
import com.stiv_apps.facecutweb.util.BackgroundGradient
import com.stiv_apps.facecutweb.util.Constants.APP_STORE_LINK
import com.stiv_apps.facecutweb.util.Constants.PLAY_STORE_LINK
import com.stiv_apps.facecutweb.util.Constants.SF_PRO_LIGHT
import com.stiv_apps.facecutweb.util.Constants.SF_PRO_MEDIUM
import com.stiv_apps.facecutweb.util.Resource
import com.stiv_apps.facecutweb.util.TextGradient
import com.stiv_apps.facecutweb.util.Theme
import com.varabyte.kobweb.compose.css.BackgroundClip
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.grayscale
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.filter
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainSection(
    breakpoint: Breakpoint,
    largeBreakpoint: Boolean,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .maxWidth(100.percent)
            .backgroundImage(BackgroundGradient)
            .padding(
                leftRight = if (breakpoint > Breakpoint.LG) 120.px
                else if (breakpoint == Breakpoint.LG) 100.px
                else if (breakpoint > Breakpoint.MD) 70.px
                else if (breakpoint == Breakpoint.MD) 50.px
                else 40.px
            ),
        horizontalAlignment = Alignment.Start
    ) {
        Header(largeBreakpoint = largeBreakpoint)
        SimpleGrid(
            modifier = Modifier.fillMaxWidth(),
            numColumns = numColumns(base = 1, xl = 2)
        ) {
            LeftSide(
                breakpoint = breakpoint,
                largeBreakpoint = largeBreakpoint
            )
            RightSide(largeBreakpoint = largeBreakpoint)
        }
        if (!largeBreakpoint) {
            Column(
                modifier = Modifier
                    .margin(top = 24.px)
                    .fillMaxWidth(),
                verticalArrangement = Arrangement.Center
            ) {
                P(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .color(Colors.White.copy(alpha = 200))
                        .fontFamily(SF_PRO_LIGHT)
                        .fontSize(1.cssRem)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            window.open("/privacy")
                        }
                        .textAlign(TextAlign.Center)
                        .toAttrs()
                ) {
                    Text(value = "Privacy Policy")
                }
                P(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .color(Colors.White.copy(alpha = 200))
                        .fontFamily(SF_PRO_LIGHT)
                        .fontSize(1.cssRem)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            window.open("/terms")
                        }
                        .textAlign(TextAlign.Center)
                        .toAttrs()
                ) {
                    Text(value = "Terms of Service")
                }
                P(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .margin(
                            top = 12.px,
                            bottom = 25.px
                        )
                        .color(Colors.White.copy(alpha = 127))
                        .fontFamily(SF_PRO_LIGHT)
                        .fontSize(1.cssRem)
                        .textAlign(TextAlign.Center)
                        .toAttrs()
                ) {
                    Text(
                        value = "support@facecut.app"
                    )
                }
            }
        }
    }
}

@Composable
private fun LeftSide(
    breakpoint: Breakpoint,
    largeBreakpoint: Boolean,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.Center
    ) {
        Surface(
            modifier = Modifier
                .height(if (largeBreakpoint) 100.px else 0.px)
        ) {}
        P(
            attrs = TextSelectionStyle.toModifier()
                .fillMaxWidth()
                .margin(bottom = 0.px)
                .backgroundImage(TextGradient)
                .background { this.clip(BackgroundClip.Text) }
                .color(Color.transparent)
                .fontFamily(SF_PRO_MEDIUM)
                .fontSize(if (largeBreakpoint) 6.cssRem else 4.cssRem)
                .lineHeight(value = if (largeBreakpoint) 1.1 else 1.1)
                .textAlign(
                    if (largeBreakpoint) TextAlign.Start
                    else TextAlign.Center
                )
                .toAttrs()
        ) {
            Text(value = "Portrait Thumbnails")
        }
        P(
            attrs = TextSelectionStyle.toModifier()
                .fillMaxWidth()
                .margin(top = 0.px)
                .color(Theme.Text.rgb)
                .fontFamily(SF_PRO_MEDIUM)
                .fontSize(if (largeBreakpoint) 6.cssRem else 4.cssRem)
                .lineHeight(value = if (largeBreakpoint) 1.1 else 1.1)
                .textAlign(
                    if (largeBreakpoint) TextAlign.Start
                    else TextAlign.Center
                )
                .toAttrs()
        ) {
            Text(value = "in minutes!")
        }
        Surface(
            modifier = Modifier
                .height(if (largeBreakpoint) 20.px else 20.px)
        ) {}
        P(
            attrs = TextSelectionStyle.toModifier()
                .fillMaxWidth()
                .margin(topBottom = 0.px)
                .color(Theme.TextLowVisibility.rgb)
                .fontFamily(SF_PRO_LIGHT)
                .fontSize(if (largeBreakpoint) 1.5.cssRem else 1.3.cssRem)
                .lineHeight(value = if (largeBreakpoint) 1.6 else 1.4)
                .textAlign(
                    if (largeBreakpoint) TextAlign.Start
                    else TextAlign.Center
                )
                .toAttrs()
        ) {
            Text(
                value = "Tired of creating low quality, ugly thumbnails that do not convert? You don't need to pay a professional designer an extra $20 per thumbnail, instead do it yourself!"
            )
        }
        Surface(modifier = Modifier.height(50.px)) {}
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = if (largeBreakpoint) Arrangement.Start
            else Arrangement.Center
        ) {
            Image(
                modifier = StoreImageStyle.toModifier()
                    .width(if (breakpoint <= Breakpoint.SM) 8.5.cssRem else 10.cssRem)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.open(url = PLAY_STORE_LINK)
                    },
                src = Resource.Icon.PLAY_STORE,
                alt = "Play Store Image"
            )
            Surface(modifier = Modifier.width(size = 20.px)) {}
            Image(
                modifier = StoreImageStyle.toModifier()
                    .width(if (breakpoint <= Breakpoint.SM) 8.5.cssRem else 10.cssRem)
                    .cursor(Cursor.Pointer)
                    .filter(grayscale(100.percent))
                    .onClick {
                        window.open(url = APP_STORE_LINK)
                    },
                src = Resource.Icon.APP_STORE,
                alt = "App Store Image"
            )
//            Tooltip(
//                modifier = Modifier
//                    .padding(
//                        topBottom = 4.px,
//                        leftRight = 12.px
//                    )
//                    .borderRadius(r = 12.px)
//                    .fontFamily(SF_PRO_REGULAR),
//                target = ElementTarget.PreviousSibling,
//                text = "Coming soon"
//            )
        }
        if (largeBreakpoint) {
            Row(modifier = Modifier.fillMaxWidth()) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    P(
                        attrs = TextSelectionStyle.toModifier()
                            .margin(bottom = 0.px, top = 100.px, right = 20.px)
                            .color(Colors.White.copy(alpha = 200))
                            .fontFamily(SF_PRO_LIGHT)
                            .fontSize(1.cssRem)
                            .lineHeight(value = 1.1)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                window.open("/privacy")
                            }
                            .toAttrs()
                    ) {
                        Text(value = "Privacy Policy")
                    }
                    P(
                        attrs = TextSelectionStyle.toModifier()
                            .margin(bottom = 0.px, top = 100.px, right = 20.px)
                            .color(Colors.White.copy(alpha = 200))
                            .fontFamily(SF_PRO_LIGHT)
                            .fontSize(1.cssRem)
                            .lineHeight(value = 1.1)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                window.open("/terms")
                            }
                            .toAttrs()
                    ) {
                        Text(value = "Terms of Service")
                    }
                    P(
                        attrs = TextSelectionStyle.toModifier()
                            .margin(bottom = 0.px, top = 100.px)
                            .color(Colors.White.copy(alpha = 127))
                            .fontFamily(SF_PRO_LIGHT)
                            .fontSize(1.cssRem)
                            .lineHeight(value = 1.1)
                            .toAttrs()
                    ) {
                        Text(value = "support@facecut.app")
                    }
                }
            }
        }
    }
}

@Composable
private fun RightSide(largeBreakpoint: Boolean) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = if (largeBreakpoint) Alignment.CenterStart else Alignment.Center
    ) {
        Image(
            modifier = Modifier
                .margin(
                    top = if (largeBreakpoint) 0.px else 100.px,
                    left = if (largeBreakpoint) 100.px else 0.px
                )
                .fillMaxWidth()
                .maxWidth(600.px),
            src = Resource.Icon.APP_PREVIEW,
            alt = "Application Preview"
        )
    }
}